import { ThemeColors } from '~/themes/colors'

export interface VersionBannerColors {
  Background: ThemeColors
  CloseIconColor: ThemeColors
  FontColor: ThemeColors
}

export const versionBannerColors: VersionBannerColors = {
  Background: {
    default: 'gray.100',
  },
  CloseIconColor: {
    default: 'gray.900',
  },
  FontColor: {
    default: 'gray.900',
  },
}
